import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import fanyiPic from '@/assets/fanyi.png';
import TinymceEditor from '@/components/tinymce';
import { upload } from '@/services/common';
import { updateArticle, getArticleDetail } from '@/services/article';
import FooterToolBar from '@/components/tool/FooterToolBar';
import Result from '@/components/result/Result';
export default {
  name: 'editArticle',
  components: {
    TinymceEditor: TinymceEditor,
    FooterToolBar: FooterToolBar,
    Result: Result
  },
  i18n: require('./i18n-article'),
  data: function data() {
    return {
      saveLoading: false,
      articleHost: '',
      contentErr: false,
      fanyiPic: fanyiPic,
      tabKey: 0,
      dataForm: {
        id: '',
        url: '',
        title: '',
        traceCode: '',
        statisticsFlag: "",
        //文章追踪状态（0: 不统计  1：统计）
        //新建/修改 字段
        contentList: []
      },
      previewUrl: "",
      //预览地址前缀
      rules: {
        title: [{
          required: true,
          message: this.$t('articlelist.articleNameErr'),
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.dataForm.id = self.$route.query.id;
    self.init();
  },
  methods: {
    /* getshowFYStatus(data) {
    	let self = this;
    	let contentListClone = self.dataForm.contentList;
    	for (let one of contentListClone) {
    		one.showFY = true;
    	}
    			console.log(data);
    }, */
    tabChange: function tabChange(activeKey) {
      //tabs 切换事件
      var self = this;
      self.tabKey = activeKey;
      /* let contentListClone = self.dataForm.contentList;
      	for (let one of contentListClone) {
      		one.showFY = false;
      	} */
    },
    imgUpload: function imgUpload(blobInfo, success, failure) {
      var formData = new FormData();
      formData.append('type', 8);
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      upload(formData).then(function (res) {
        if (res.data.code == 200) {
          success(res.data.data.urlpath + res.data.data.uploadfilepath);
        }
      });
    },
    //富文本反转义html
    escape2Html: function escape2Html(str) {
      var arrEntities = {
        'lt': '<',
        'gt': '>',
        'nbsp': ' ',
        'amp': '&',
        'quot': '"'
      };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
        return arrEntities[t];
      });
    },
    init: function init() {
      var self = this;
      var defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      var languageList = JSON.parse(localStorage.getItem('langList'));
      self.articleHost = localStorage.getItem('articleHost');
      getArticleDetail(self.dataForm.id).then(function (res) {
        if (res.data.code == 200) {
          var dataForm = res.data.data;
          self.dataForm.title = dataForm.title;
          self.dataForm.url = dataForm.url;
          self.dataForm.traceCode = dataForm.traceCode;
          self.dataForm.statisticsFlag = dataForm.statisticsFlag;
          self.previewUrl = dataForm.previewUrl;

          //初始化多语言
          var dataList = [];
          languageList.forEach(function (item) {
            var objDetail = {};
            objDetail.langId = item.langId;
            objDetail.languageName = item.langName;
            //初始化 list  list为空时数据库中不插入，需要初始化
            objDetail.content = '';
            objDetail.showFY = false;
            objDetail.required = false;
            if (item.langId == defaultLangObj.langId) {
              objDetail.required = true;
            }
            dataForm.list.forEach(function (item2) {
              if (item.langId == item2.langId) {
                objDetail.content = self.escape2Html(item2.content);
              }
            });
            dataList.push(objDetail);
          });
          self.dataForm.contentList = dataList;
        }
      });
    },
    /* 预览 */preview: function preview() {
      var routeData = this.previewUrl + '?id=' + this.dataForm.id + '&type=preview';
      window.open(routeData, '_blank');
    },
    /* 确定添加 */save: function save() {
      var _this = this;
      var self = this;
      var _iterator = _createForOfIteratorHelper(self.dataForm.contentList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          //内容必填为空时错误提示添加
          if (item.required && item.content == '') {
            self.contentErr = true;
            self.tabKey = 0;
            return;
          } else if (item.required && item.content) {
            self.contentErr = false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          var param = {
            id: self.dataForm.id,
            title: self.dataForm.title,
            statisticsFlag: self.dataForm.statisticsFlag,
            traceCode: self.dataForm.traceCode,
            url: self.dataForm.url,
            list: self.dataForm.contentList
          };
          self.saveLoading = true;
          updateArticle(param).then(function (res) {
            if (res.data.code == 200) {
              self.saveLoading = false;
              _this.$message.success(_this.$t('public.updateSuccessfully'));
            } else {
              self.saveLoading = false;
            }
          }).finally(function () {
            self.saveLoading = false;
          });
        }
      });
    },
    refreshPage: function refreshPage() {
      this.init();
      this.showSuccess = false;
    },
    goList: function goList() {
      this.$router.push({
        name: 'articlelist'
      });
    }
  }
};